export const ForbiddenKeys = new Set([
    'constructor',
    '__proto__',
    'prototype',
    'call',
    'apply',
    'bind',
]);
